export default class IpagPaymentStatus {

    static APROVADO = '5'
    static APROVADO_CAPTURADO = '8'
    static RECUSADO = '7'

}


// WEBPACK FOOTER //
// ./src/enums/IpagPaymentStatus.js